import { Calendar, DollarSign } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { InvoiceDto } from "@shared/types/InvoiceDto";
import { formatDate, formatCurrency, getStatusConfig } from "./utils";

interface InvoiceStatsProps {
  invoice: InvoiceDto;
}

export function InvoiceStats({ invoice }: InvoiceStatsProps) {
  const statusConfig = getStatusConfig(invoice.status);
  const StatusIcon = statusConfig?.icon;

  return (
    <div className="grid gap-4 md:grid-cols-4">
      <div className="border border-border/50 rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Status</p>
        <div className="flex items-center gap-2">
          <Badge variant="outline" className={statusConfig?.className}>
            {StatusIcon && <StatusIcon className="h-3.5 w-3.5 mr-1" />}
            {statusConfig?.label}
          </Badge>
        </div>
      </div>
      <div className="border border-border/50 rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Total Amount</p>
        <p className="text-xl font-bold flex items-center gap-1">
          <DollarSign className="h-5 w-5" />
          {formatCurrency(invoice.amount).replace("$", "")}
        </p>
      </div>
      <div className="border border-border/50 rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Amount Paid</p>
        <p className="text-xl font-bold text-emerald-500">
          {formatCurrency(invoice.paid)}
        </p>
      </div>
      <div className="border border-border/50 rounded-lg p-4">
        <p className="text-sm text-muted-foreground mb-1">Created</p>
        <p className="text-sm font-medium flex items-center gap-1.5">
          <Calendar className="h-4 w-4" />
          {formatDate(invoice.createdAt)}
        </p>
      </div>
    </div>
  );
}
